import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

// The chevron half of the split button — narrow, no left border doubling.
// Height matches the Vitals/Profile tabs and the "All Runs" row buttons (24px).
export const ChevronButton = styled(Button)(() => ({
  paddingLeft: 4,
  paddingRight: 4,
  minWidth: 28,
  minHeight: 24,
  height: 24,
  "& .MuiSvgIcon-root": { fontSize: 16 },
}));
